module.exports = __webpack_public_path__ + "static/embed-dash.bd1dcb57.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/embed-dash.png
// module id = 142
// module chunks = 5193848062471 35783957827783